module.exports = __webpack_public_path__ + "static/media/giri.62b89348.png";